/**
 * 金钱过滤器
 * @param {string|number} value - 要格式化的值
 * @returns {string} 格式化后的金钱字符串
 */
const money = (value) => {
  if (value === null || value === undefined || value === '') {
    return '0.00'
  }
  
  // 将字符串数字转换为数字类型
  const num = Number(value)
  
  // 检查转换后的值是否为有效数字
  if (isNaN(num)) {
    return '0.00'
  }
  
  // 使用toFixed保留2位小数，并添加千分位分隔符
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 导出所有过滤器
export default {
  money
} 